export const TOGGLE_ALL_STYLE_COLORS =
  'REMOVE_STYLE_COLORS_WITHOUT_QUANTITIES/TOGGLE_ALL_STYLE_COLORS'
export const TOGGLE_STYLE_COLOR =
  'REMOVE_STYLE_COLORS_WITHOUT_QUANTITIES/TOGGLE_STYLE_COLOR'
export const RESET_SELECTED_STYLE_COLORS =
  'REMOVE_STYLE_COLORS_WITHOUT_QUANTITIES/RESET_SELECTED_STYLE_COLORS'
